const actions = {
	GET_REPEAT_SENTENCE: 'GET_REPEAT_SENTENCE',
	GET_REPEAT_SENTENCE_SUCCESS: 'GET_REPEAT_SENTENCE_SUCCESS',

	CREATE_NEW_QUESTION_REPEAT_SENTENCE: 'CREATE_NEW_QUESTION_REPEAT_SENTENCE',
	CREATE_NEW_QUESTION_REPEAT_SENTENCE_SUCCESS: 'CREATE_NEW_QUESTION_REPEAT_SENTENCE_SUCCESS',

	DELETE_REPEAT_SENTENCE: 'DELETE_REPEAT_SENTENCE',
	DELETE_REPEAT_SENTENCE_SUCCESS: 'DELETE_REPEAT_SENTENCE_SUCCESS',

	GET_REPEAT_SENTENCE_DETAIL: 'GET_REPEAT_SENTENCE_DETAIL',
	GET_REPEAT_SENTENCE_DETAIL_SUCCESS: 'GET_REPEAT_SENTENCE_DETAIL_SUCCESS',

	UPDATE_REPEAT_SENTENCE_DETAIL: 'UPDATE_REPEAT_SENTENCE_DETAIL',
	UPDATE_REPEAT_SENTENCE_DETAIL_SUCCESS: 'UPDATE_REPEAT_SENTENCE_DETAIL_SUCCESS',

	SPEAKING_LOADING_FALSE: 'SPEAKING_LOADING_FALSE',
	//#region CRUD

	getRepeatSentence: (model) => ({
		type: actions.GET_REPEAT_SENTENCE,
		payload: { model },
	}),

	createQuesRepeatSentence: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_REPEAT_SENTENCE,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getRepeatSentenceDetail: (id) => ({
		type: actions.GET_REPEAT_SENTENCE_DETAIL,
		payload: { id },
	}),

	updateRepeatSentenceDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_REPEAT_SENTENCE_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteRepeatSentence: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_REPEAT_SENTENCE,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
